import React, { FC } from 'react';

import { Button } from '@clearcover/atlas';
import { ButtonGroup } from 'Shared/components/ButtonGroup';

import styles from './styles.module.css';

type ModalPromptContentType = {
  cancelButtonText: string;
  confirmButtonText: string;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
  children?: React.ReactNode;
};

export const ModalPromptContent: FC<ModalPromptContentType> = ({
  children,
  cancelButtonText,
  confirmButtonText,
  onConfirm,
  onCancel,
  isSubmitting,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.body}>{children}</div>
      <ButtonGroup alignRight>
        <Button
          data-testid="modal-prompt-cancel"
          variant="secondary"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {cancelButtonText}
        </Button>
        <Button
          data-testid="modal-prompt-continue"
          variant="primary"
          type="submit"
          onClick={onConfirm}
          isSubmitting={isSubmitting}
        >
          {confirmButtonText}
        </Button>
      </ButtonGroup>
    </div>
  );
};
